import { useEffect, useRef, useState } from 'react';

/**
 * Seconds left until `expiresAt` (epoch ms), ticking once a second.
 *
 * Proietta ogni volta da `Date.now()` invece di sottrarre 1 al valore
 * precedente: un contatore a decremento si ferma insieme al `setInterval`
 * quando la scheda va in background, e al ritorno mostra un numero che non e'
 * mai esistito. Qui il numero e' sempre la differenza vera, quindi riprende
 * giusto — o e' gia' a zero, che e' la risposta corretta.
 *
 * `onExpire` scatta UNA volta sola per ogni scadenza (la ref evita che un
 * ri-render la richiami), e non scatta affatto se si monta gia' scaduti.
 * Restituisce 0 quando non c'e' nessuna scadenza armata.
 */
export function useExpiryCountdown(expiresAt: number | null, onExpire?: () => void): number {
  const [seconds, setSeconds] = useState(() =>
    expiresAt == null ? 0 : Math.max(0, Math.ceil((expiresAt - Date.now()) / 1000))
  );

  // L'ultima callback senza rientrare nell'effetto: passarla fra le dipendenze
  // riarmerebbe il timer a ogni render del chiamante.
  const onExpireRef = useRef(onExpire);
  onExpireRef.current = onExpire;

  useEffect(() => {
    if (expiresAt == null) {
      setSeconds(0);
      return;
    }
    let fired = false;
    let timer = 0;
    const tick = () => {
      const remaining = Math.max(0, Math.ceil((expiresAt - Date.now()) / 1000));
      setSeconds(remaining);
      if (remaining === 0 && !fired) {
        fired = true;
        window.clearInterval(timer);
        onExpireRef.current?.();
      }
    };
    timer = window.setInterval(tick, 1000);
    tick(); // subito, altrimenti il primo secondo mostra il valore iniziale stantio
    return () => window.clearInterval(timer);
  }, [expiresAt]);

  return seconds;
}
